import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/material";
import { CustomCellRendererProps } from "ag-grid-react";
import React from "react";

import { ClickToSelect } from "../ClickToSelect";

import type { PlanEditorRowData } from "../../types/values.types";

/**
 * Cell renderer for popover select fields
 * Displays the selected value with an edit icon
 */
export const PopoverSelectRenderer: React.FC<
  CustomCellRendererProps<PlanEditorRowData, string>
> = (props) => {
  const { value } = props;

  // Empty state - no value selected
  if (!value || value === "") {
    return <ClickToSelect />;
  }

  // Display the selected value with edit icon
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        gap: 0.5,
        cursor: "pointer",
        width: "100%",
        fontSize: "inherit",
        color: "inherit",
        fontFamily: "inherit",
      }}
    >
      <span style={{ flex: 1, marginLeft: 20 }}>{value}</span>
      <EditIcon fontSize="small" sx={{ opacity: 0.5 }} />
    </Box>
  );
};
